import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { authorize } from 'utils/auth';
import { FormattedMessage } from 'ui/i18n';

import './NavTab.scss';

export default class OrderNav extends Component {
	static propTypes = {
		api: PropTypes.array,
		route: PropTypes.string,
		name: PropTypes.string,
	};

	static defaultProps = {
		api: [''],
		route: '',
		name: '',
	};

	render() {
		return (
			<li className="NavTab">
				{authorize(
					this.props.api,
					<NavLink to={this.props.route} exact activeClassName="active">
						<FormattedMessage id={this.props.name} />
					</NavLink>
				)}
			</li>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/NavTab/index.js